import { PAGINATION_GAP } from './constants'

export const pagination = (
  currentPage,
  total,
  delta = 1,
  gap = PAGINATION_GAP,
) => {
  if (total <= 1) return [1]

  const center = [currentPage]

  // no longer O(1) but still very fast
  for (let i = 1; i <= delta; i++) {
    center.unshift(currentPage - i)
    center.push(currentPage + i)
  }

  const filteredCenter = center.filter((page) => page > 1 && page < total)

  const includeLeftGap = currentPage > 3 + delta
  const includeLeftPages = currentPage === 3 + delta
  const includeRightGap = currentPage < total - (2 + delta)
  const includeRightPages = currentPage === total - (2 + delta)

  if (includeLeftPages) filteredCenter.unshift(2)
  if (includeRightPages) filteredCenter.push(total - 1)
  if (includeLeftGap) filteredCenter.unshift(gap)
  if (includeRightGap) filteredCenter.push(gap)

  return [1, ...filteredCenter, total]
}

export const paginationNumberOnly = (
  currentPage,
  total,
  numberPageShow = 5,
) => {
  if (total <= numberPageShow) {
    return [...new Array(total)].map((_, index) => index + 1)
  } else {
    if (currentPage < Math.ceil(numberPageShow / 2)) {
      return [...new Array(numberPageShow)].map((_, index) => index + 1)
    }

    if (
      currentPage <= total &&
      currentPage >= total - Math.floor(numberPageShow / 2)
    ) {
      return [...new Array(numberPageShow)].map(
        (_, index) => total - numberPageShow + index + 1,
      )
    }

    const range = Math.floor(numberPageShow / 2)
    let minPage = currentPage - range
    let maxPage = currentPage + range

    for (let i = 0; i <= range; i++) {
      if (minPage < 0) {
        minPage += 1
      }

      if (maxPage > total) {
        maxPage -= 1
      }
    }

    return [...new Array(maxPage - minPage + 1)].map(
      (_, index) => index + minPage,
    )
  }
}
